import { useContext } from 'react';

import { useShowLoyaltyProgram } from '../../hooks/useShowLoyaltyProgram';
import { useShowReferAfriend } from '../../hooks/useShowReferAfriend';

import { FeatureDiscoveryNotificationContext } from './FeatureDiscoveryNotificationProvider';

export const useFeatureDiscoveryNotification = () => {
    const context = useContext(FeatureDiscoveryNotificationContext);
    const showLoyaltyProgram = useShowLoyaltyProgram();
    const showReferAfriend = useShowReferAfriend();

    const canShowMyBenefitsNotification =
        showLoyaltyProgram && context.hasFeatureDiscoveryNotification('page.myBenefits');

    const canShowReferAfriendNotification =
        showReferAfriend && context.hasFeatureDiscoveryNotification('page.referAFriend');

    return {
        ...context,
        hasNotifications: canShowMyBenefitsNotification || canShowReferAfriendNotification,
        canShowMyBenefitsNotification,
        canShowReferAfriendNotification,
    };
};
